// 팝업 그림을 올리기 전에 줄인다 — 가로 최대 1000px JPEG(흰 바탕). 휴대폰 사진도 수백 KB 로 줄어
// 첫 화면이 가볍고 서버 한도(3MB)에 걸리지 않는다. 투명 PNG 는 흰 바탕으로 채운다(그냥 바꾸면 검게 나온다).
export const MAX_POPUP_WIDTH = 1000;

const loadImage = (file: File) =>
  new Promise<HTMLImageElement>((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('그림 파일을 열 수 없습니다. JPG·PNG 로 다시 골라 주세요.'));
    };
    img.src = url;
  });

export const fileToPopupImage = async (file: File): Promise<string> => {
  if (!/^image\//.test(file.type)) throw new Error('그림 파일(JPG·PNG)을 골라 주세요.');
  const img = await loadImage(file);
  const scale = Math.min(1, MAX_POPUP_WIDTH / img.naturalWidth);
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(img.naturalWidth * scale);
  canvas.height = Math.round(img.naturalHeight * scale);
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('이 브라우저에서는 그림을 줄일 수 없습니다.');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL('image/jpeg', 0.85);
};
